export default __webpack_public_path__ + "static/media/youtubeframe.9ad82fc7ca49d3527cbe99232f626f9a.svg";